/**
* @description Initializes the slick slider carousels
*/

const initSlickSlider = {
    /**
     * @function
     * @description - initializes each instance of the carousel found, based on the param passed
     */
    initSlickSlider: function(el, options) {
        const $element = $(el);

        $element.each(function() {
            const $this = $(this);

            if ($this.hasClass("slick-initialized")) {
                return false;
            }

            $this.slick(options);
            return true;
        });
    },

    init: function () {
        let $slickElement = $(".slick-slider");

        if (!$slickElement) {
            $slickElement = $(".slick-slider");
        }

        this.initSlickSlider($slickElement);
    },

    /**
     * @function
     * @description - Creates carousel in container based on params, with set options and predefined images.
     * @param {Object} imgs Images elements which will be appended into carousel.
     * @param {Object} productContainer Container, which will be constructed into carousel.
     * @param {Object} options Options which will be passed to slick slider initiazation.
     */
    create: function (imgs, productContainer, options) {
        const $carousel = productContainer.find(".pdp-carousel");
        const $thumbnailWrapper = $(".thumbnails-wrapper");
        if ($carousel.is(".slick-slider")) {
            $carousel.slick("unslick");
        }
        $carousel.empty();
        $thumbnailWrapper.empty();
        imgs.large.forEach((img, i) => {
            $(`<a class="trigger-photo-swipe"
                   data-pswp-src="${imgs.zoomtilesmall[i].url}"
                   data-pswp-width="800"
                   data-pswp-height="1066"
                >
                  <img data-src="${img.url}"
                      data-original-img="${imgs.originaltile[i].url}"
                      data-original-img-index="${i}"
                      class="d-block img-fluid lazyload pdp-carousel-img"
                      alt="${img.alt} image number ${i}"
                      itemprop="image"
                  />
               </a>`)
                .appendTo($carousel);

            this.updateThumbnail(img, i, imgs);
        });

        if (imgs.large.length > 1) {
            this.initSlickSlider($carousel, options);
        }
    },

    updateThumbnail: function (img, imageIndex, imgs) {
        const $thumbnailWrapper = $(".thumbnails-wrapper");
        $(`<a class="trigger-photo-swipe ${imgs.minitile.length < 2 ? "d-none" : ""}"
            data-pswp-src="${imgs.zoomtilesmall[imageIndex].url}"
            data-pswp-width="800"
            data-pswp-height="1066"
        >
            <img data-src="${img.url}"
                data-original-img="${imgs.originaltile[imageIndex].url}"
                data-zoom-sm="${imgs.zoomtilesmall[imageIndex].url}"
                data-thumbnail-index="${imageIndex}"
                class="d-block img-fluid lazyload pdp-thumbnail"
                alt="${img.alt}"
            />
        </a>`)
            .appendTo($thumbnailWrapper);
    }
};

export default initSlickSlider;
